import React from 'react';

const SocialProofSection = ({ credentialBadges }) => {
  const testimonials = [
    {
      initials: "HB",
      quote: "I've worked with businesses in insurance and benefits for a decade. Amplify is one of the rare payroll and PEO companies that actually delivers on experience, service, and value. They stand up to the larger, more-marketed competition easily.",
      name: "HB",
      company: "25 employees, professional services"
    },
    {
      initials: "MW",
      quote: "Amplify HR helped move us from a percentage payroll admin fee to a flat admin fee saving us a lot of money. We've now been an Amplify HR client for over 4 years and enjoy working with our dedicated contacts Karen for payroll, Tracy & Mark for Benefits and Francis for HR. It is with great pleasure that I recommend the team at Amplify HR and suggest you look at what they have to offer.",
      name: "MW",
      company: "44 employees, technology services"
    },
    {
      initials: "YB",
      quote: "I would highly recommend Amplify HR to any organization seeking a professional and reliable HR partner. Their team expertly manages all the day-to-day functions of an enterprise-level HR department, allowing us to focus on our core business. Beyond their capabilities, the individuals supporting us are truly exceptional—knowledgeable, responsive, and an absolute pleasure to work with.",
      name: "YB",
      company: "72 employees, professional services"
    },
    {
      initials: "MW",
      quote: "What has impressed me the most is the long-term consistency of support from mostly the same key people over seven years. Answers from their team come quickly. And because we are still dealing with the same key members after 7 years, their solutions are reflective of my company's history with Amplify HR.",
      name: "MW",
      company: "117 employees"
    },
    {
      initials: "LG",
      quote: "Amplify HR has been a pleasure to work with from implementation and integration through everyday ongoing experiences. Every person has been knowledgeable and professional that I have interacted with in every department. It is never an easy process to move to a new PEO but this was a very smooth transition and I find the Amplify HR staff the best I have ever worked with. I always feel like I have a resource and all the support I would ever need. I do not feel there is anything more I need than all the services they offer me. The time and labor dashboard is an easy tool that gives me full visibility into my employees time allocation, time card and so much more. Everything is right at my fingertips. There is never a day where I am not in the Amplify HR platform multiple times throughout the day. I highly recommend Amplify HR over any other PEO, in fact, I already have recommended them to a business advisor and he moved his entire company over after I could not stop raving!",
      name: "LG",
      company: "27 employees, marketing company"
    }
  ];

  return (
    <section className="social-proof-section">
      <div className="section-container">
        <h2 className="section-headline">You're Not the Only One Frustrated</h2>
        <div className="testimonials-scroll-container">
          <div className="testimonials-scroll-track">
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div key={`${testimonial.name}-${index}`} className="testimonial-card scroll-card">
                <div className="testimonial-avatar">{testimonial.initials}</div>
                <blockquote className="testimonial-quote">
                  "{testimonial.quote}"
                </blockquote>
                <div className="testimonial-attribution">
                  <div className="testimonial-name">{testimonial.name}</div>
                  <div className="testimonial-company">{testimonial.company}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <p className="social-line">
          Hundreds of businesses have made the switch from big box PEOs to Amplify HR.
        </p>
        <div className="credential-badges">
          {credentialBadges.map((badge) => (
            <div key={badge.alt} className="credential-badge">
              <img src={badge.src} alt={badge.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
